import {
  createAdditionalAttributionImpressionKey,
  TopsortAdsContext,
  shouldTrackAdditionalAttributionImpression
} from './adsAttributionContext';
import { getTopsortProductId } from './getTopsortProductId';
import { sendTopsortEvent } from './sendTopsortEvent';

export const trackAdditionalAttributionImpression = ({
  adsContext,
  trackedKeys,
  idBanner,
  item
}: {
  adsContext: TopsortAdsContext;
  trackedKeys: Set<string>;
  idBanner: string;
  item: {
    id: string | number;
    url?: string;
  };
}): void => {
  const productId = getTopsortProductId({
    id: item.id,
    url: item.url
  });

  const impressionKey = createAdditionalAttributionImpressionKey({
    bidId: adsContext.bidId,
    landingPath: adsContext.landingPath,
    productId
  });

  if (
    !shouldTrackAdditionalAttributionImpression({
      impressionKey,
      trackedKeys
    })
  ) {
    return;
  }

  sendTopsortEvent({
    type: 'impression',
    resolvedBidId: adsContext.bidId,
    idBanner,
    additionalAttribution: { id: productId, type: 'product' }
  });
};
